import { render, staticRenderFns } from "./GoldenTicket.vue?vue&type=template&id=7a72b88f&scoped=true&"
import script from "./GoldenTicket.vue?vue&type=script&lang=js&"
export * from "./GoldenTicket.vue?vue&type=script&lang=js&"
import style0 from "./GoldenTicket.vue?vue&type=style&index=0&id=7a72b88f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a72b88f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
